import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';

// core2/platform/dm/app-login-subject-to-tenant-link-audit-trails/backoffice-ep 

@Injectable({
  providedIn: 'root'
})
export class AppLoginSubjectToTenantLinkAuditTrailBackofficeService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-login-subject-to-tenant-link-audit-trails/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-login-subject-to-tenant-link-audit-trails/backoffice-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-login-subject-to-tenant-link-audit-trails/backoffice-ep';
    this.httpClient = http;
  }
}
